import { useMemo } from "react";
import { useQuery } from "@apollo/client";

import { LOAD_NOTIFICATION_VARIABLES_QUERY } from "globals/graphql";
import { NotificationVariable } from "types";

function useNotificationVariables(availableVariables: string[]) {
  // queries
  const { data, loading } = useQuery<{
    loadNotificationVariables: NotificationVariable[];
  }>(LOAD_NOTIFICATION_VARIABLES_QUERY, {
    fetchPolicy: "cache-and-network",
  });

  const notificationVariables = useMemo(() => {
    const notificationVariablesLoaded = data?.loadNotificationVariables || [];

    return notificationVariablesLoaded.filter((variable) =>
      availableVariables.includes(variable.key)
    );
  }, [data, availableVariables]);

  return { notificationVariables, loading };
}

export default useNotificationVariables;
